<template>
  <article class="order_details">
    <header class="pages_title">
      <h3>订单号:{{ orderData.OrderNum }}</h3>
    </header>

    <section class="order_details_container">
      <div class="order_details_passenger_separation flex_wrap"><h3>订单详情</h3></div>
      <div class="order_details_route">
        <div class="order_details_route_info">
          <p class="">
            <span>订单类型:</span>
            <span v-if="orderData.OrderType == 0">普通预约</span>
            <span v-else-if="orderData.OrderType == 1">车票接送</span>
            <span v-else-if="orderData.OrderType == 2">业务接送</span>
            <span v-else-if="orderData.OrderType == 3">合作商户</span>
          </p>
          <p>
            <span>预约时间 :</span>
            <span>{{ orderData.bookingDate }}</span>
          </p>
          <p>
            <span>上车地址 :</span>
            <span class="text_wrapping">{{ orderData.StartDistrict + '-' + orderData.bookingStartAddr }}</span>
          </p>
          <p class="">
            <span>到达地点 :</span>
            <span class="text_wrapping">{{ orderData.EndDistrict + '-' + orderData.bookingEndAddr }}</span>
          </p>
          <p class="">
            <span>客户电话 :</span>
            <span class="text_wrapping">{{ orderData.riderPhone }}</span>
          </p>
          <p class="">
            <span>行李件数 :</span>
            <span class="text_wrapping">{{ orderData.LuggageCount }}</span>
          </p>
          <p class="">
            <span>旅客人数 :</span>
            <span class="text_wrapping">{{ orderData.MemberCount }}</span>
          </p>
          <p class="">
            <span>下单时间 :</span>
            <span class="text_wrapping">{{ orderData.CreateDate }}</span>
          </p>
          <p class="">
            <span>订单进度 :</span>
            <span class="text_wrapping">{{ orderState[orderData.OrderState] }}</span>
          </p>
          <p class="">
            <span>备注：</span>
            <span class="text_wrapping">{{ orderData.UserRemarks }}</span>
          </p>
          <p class="">
            <span>总价 :</span>
            <span class="text_wrapping">{{ orderData.TotalPrice }}元</span>
          </p>
        </div>
      </div>
    </section>
  </article>
</template>

<script>
import orderApi from '../request/orderApi';
import baseTool from '../utils/baseFunction';
export default {
  name: 'AppointOrderDetailsInfo',
  data() {
    return {
      orderData: {},
      orderId: '',
      orderState: ['待支付', '已支付', '已完成', '发起退款', '退款成功', '等待客服']
    };
  },
  activated() {
    this.orderId = this.$route.params.id;
    this.getOrderData();
  },
  methods: {
    getOrderData() {
      let that = this;
      orderApi.getAppointOrderInfo(this.$store.state.user.OpenId, this.orderId).then(sucRes => {
        if (sucRes.success) {
          let val = sucRes.data;
          val.CreateDate = baseTool.formatDateStr(val.CreateDate, 'full'); // 2018.11.5
          val.bookingDate = val.bookingDate != null ? baseTool.formatDateStr(val.bookingDate, 'full') : '待客服确认';
          this.orderData = val;
        }
      });
    }
  }
};
</script>

<style></style>



// WEBPACK FOOTER //
// src/components/AppointOrderDetailsInfo.vue